import script from "./CustomSentEmailsQuery.vue?vue&type=script&lang=js"
export * from "./CustomSentEmailsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__